import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  EntityModelLipid,
  Lipid,
  LipidControllerService,
  PagedModelEntityModelLipid
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";

@Component({
  selector: "app-admin-lipid",
  templateUrl: "./admin-lipid.component.html",
  styleUrls: ["./admin-lipid.component.css"],
  standalone: true,
  imports: [CrudTableComponent]
})
export class AdminLipidComponent implements OnInit {
  private controller = inject(LipidControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[];
  filterFields: string[];
  crudAdapter: CrudAdapter<PagedModelEntityModelLipid, EntityModelLipid>;

  ngOnInit() {
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "normalizedShorthandName",
        header: "Normalized Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "lipidLevel",
        header: "Structural Level",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "lipidCategory",
        header: "Category",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "lipidClass",
        header: "Class",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "lipidSpecies",
        header: "Species",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      }
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new LipidCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }
}
class LipidCrudAdapter extends CrudAdapter<
  PagedModelEntityModelLipid,
  EntityModelLipid
> {
  constructor(
    private controller: LipidControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelLipid> {
    return this.controller.lipidGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  extractEntries(entries: any): EntityModelLipid[] {
    return <EntityModelLipid[]>entries?._embedded?.lipids;
  }

  saveSingle(
    entity: EntityModelLipid,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelLipid> {
    return this.controller.lipidSaveSingle(
      <Lipid>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.lipidDeleteById(id, observe, reportProgress, options);
  }
}
